import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class AssabilMenu extends BaseEntity{
    
    assabilMenuCode : string;
    name            : string;

}
